export default "__VITE_ASSET__Dbea2e$___"